import { useLayoutEffect, useRef } from 'react';

import BrowserSupportBanner from './BrowserSupportBanner';
import MicrophoneBanner from './MicrophoneBanner';

const APP_BANNER_HEIGHT_PROPERTY = '--app-banner-height';

const getObservedHeight = (entry) => {
  const borderBoxSize = entry?.borderBoxSize;
  const borderBoxHeight = Array.isArray(borderBoxSize)
    ? borderBoxSize[0]?.blockSize
    : borderBoxSize?.blockSize;

  return borderBoxHeight ?? entry?.contentRect?.height ?? 0;
};

function AppBannerStack() {
  const stackRef = useRef(null);

  useLayoutEffect(() => {
    const stack = stackRef.current;
    if (!stack) return undefined;

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0];
      if (!entry) return;

      document.documentElement.style.setProperty(
        APP_BANNER_HEIGHT_PROPERTY,
        `${getObservedHeight(entry)}px`,
      );
    });

    observer.observe(stack);

    return () => {
      observer.disconnect();
      document.documentElement.style.removeProperty(APP_BANNER_HEIGHT_PROPERTY);
    };
  }, []);

  return (
    <div className="app-banner-stack" ref={stackRef}>
      <BrowserSupportBanner />
      <MicrophoneBanner />
    </div>
  );
}

export default AppBannerStack;
